export default [
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/home.vue"),
    meta: {
      title: "主页-成都济溪环保咨询有限公司",
    },
  },
  {
    path: "/moveAbout",
    name: "moveAbout",
    component: () => import("@/views/moveAbout/moveAbout.vue"),
    meta: {
      title: "行动展示",
    },
  },
  {
    path: "/moveAboutDetails",
    name: "moveAboutDetails",
    component: () => import("@/views/moveAbout/moveAboutDetails.vue"),
    meta: {
      title: "行动展示",
    },
  },

  {
    path: "/news",
    name: "news",
    component: () => import("@/views/home/views/news/news.vue"),
    meta: {
      title: "新闻动态",
    },
  },
  {
    path: "/news/addNews",
    name: "/news/addNews",
    component: () => import("@/views/home/views/news/addNews.vue"),
    meta: {
      title: "新闻动态",
    },
  },
  {
    path: "/news/newsType",
    name: "/news/newsType",
    component: () => import("@/views/home/views/news/newsType.vue"),
    meta: {
      title: "新闻分类",
    },
  },
  {
    path: "/news/newsDetail",
    name: "/news/newsDetail",
    component: () => import("@/views/home/views/news/newsDetail.vue"),
    meta: {
      title: "文章",
    },
  },

  {
    path: "/equipment",
    name: "equipment",
    component: () => import("@/views/home/views/equipment/equipment.vue"),
    meta: {
      title: "装备测评",
    },
  },
  {
    path: "/equipment/addEquipment",
    name: "/equipment/addEquipment",
    component: () => import("@/views/home/views/equipment/addEquipment.vue"),
    meta: {
      title: "装备发布",
    },
  },
  {
    path: "/equipment/equipmentType",
    name: "/equipment/equipmentType",
    component: () => import("@/views/home/views/equipment/equipmentType.vue"),
    meta: {
      title: "装备分类",
    },
  },
  {
    path: "/equipment/equipmentDetails",
    name: "/equipment/equipmentDetails",
    component: () =>
      import("@/views/home/views/equipment/equipmentDetails.vue"),
    meta: {
      title: "装备详情",
    },
  },
  {
    path: "/exchange",
    name: "/exchange",
    component: () => import("@/views/home/views/exchange/exchange.vue"),
    meta: {
      title: "交流中心",
    },
  },
  {
    path: "/exchange/addExchange",
    name: "/exchange/addExchange",
    component: () => import("@/views/home/views/exchange/addExchange.vue"),
    meta: {
      title: "话题发布",
    },
  },
  {
    path: "/exchangeDetail",
    name: "/exchangeDetail",
    component: () => import("@/views/home/views/exchange/exchangeDetail.vue"),
    meta: {
      title: "话题详情",
    },
  },

  {
    path: "/integral",
    name: "/integral",
    component: () => import("@/views/home/views/integral/integral.vue"),
    meta: {
      title: "积分兑换",
    },
  },
  {
    path: "/integralImg",
    name: "/integralImg",
    component: () => import("@/views/home/views/integral/integralImg.vue"),
    meta: {
      title: "积分明细",
    },
  },

  {
    path: "/integralProduct",
    name: "/integralProduct",
    component: () => import("@/views/home/views/integral/integralProduct.vue"),
    meta: {
      title: "积分商场",
    },
  },
  {
    path: "/integralProductDetails",
    name: "/integralProductDetails",
    component: () =>
      import("@/views/home/views/integral/integralProductDetails.vue"),
    meta: {
      title: "积分商场",
    },
  },
  {
    path: "/integralUser",
    name: "/integralUser",
    component: () => import("@/views/home/views/integral/integralUser.vue"),
    meta: {
      title: "积分明细",
    },
  },
  {
    path: "/integralList",
    name: "/integralList",
    component: () => import("@/views/home/views/integral/integralList.vue"),
    meta: {
      title: "充值记录",
    },
  },
  {
    path: "/integralListDetails",
    name: "/integralListDetails",
    component: () =>
      import("@/views/home/views/integral/integralListDetails.vue"),
    meta: {
      title: "充值明细",
    },
  },

  {
    path: "/orderCart",
    name: "/orderCart",
    component: () => import("@/views/home/views/order/orderCart.vue"),
    meta: {
      title: "购物车",
    },
  },
  {
    path: "/orderCreate",
    name: "/orderCreate",
    component: () => import("@/views/home/views/order/orderCreate.vue"),
    meta: {
      title: "创建订单",
    },
  },
  {
    path: "/addressAdd",
    name: "/addressAdd",
    component: () => import("@/views/home/views/order/addressAdd.vue"),
    meta: {
      title: "收货地址",
    },
  },
  {
    path: "/listCity",
    name: "/listCity",
    component: () => import("@/views/home/views/order/listCity.vue"),
    meta: {
      title: "收货列表",
    },
  },
  {
    path: "/orderPay",
    name: "/orderPay",
    component: () => import("@/views/home/views/order/orderPay.vue"),
    meta: {
      title: "确认订单",
    },
  },
  {
    path: "/myOrder",
    name: "/myOrder",
    component: () => import("@/views/home/views/order/myOrder.vue"),
    meta: {
      title: "订单列表",
    },
  },
  {
    path: "/orderList",
    name: "/orderList",
    component: () => import("@/views/home/views/order/orderList.vue"),
    meta: {
      title: "我的订单",
    },
  },
  {
    path: "/appraise",
    name: "/appraise",
    component: () => import("@/views/home/views/order/appraise.vue"),
    meta: {
      title: "订单评价",
    },
  },
  {
    path: "/orderAppraise",
    name: "/orderAppraise",
    component: () => import("@/views/home/views/order/orderAppraise.vue"),
    meta: {
      title: "订单评价",
    },
  },
  {
    path: "/commentsList",
    name: "/commentsList",
    component: () => import("@/views/home/views/integral/commentsList.vue"),
    meta: {
      title: "订单评价",
    },
  },
];
